import { getQueryIdFromSnowflake, getStatusForQueryId, getDataFromSnowflake, getZones} from "./snowflake"
import { getSweetEDataFromSnowflake, setSweetEFleetInSnowflake } from "./sweeteSnowflake"
import { getStatusForSweetETiles } from "./sweeteTiles"

const snowflakeCalls = {
  getQueryIdFromSnowflake,
  getStatusForQueryId,
  getDataFromSnowflake,
  getZones,
  setSweetEFleetInSnowflake,
  getSweetEDataFromSnowflake,
  getStatusForSweetETiles
}

addEventListener("message", (event) => {
  postMessage({ key: "queryStarted", value: true })
  const functionName = event.data.method

  if (Object.keys(snowflakeCalls).includes(functionName)) {
    snowflakeCalls[functionName](...event.data.args).then(sfResult => {
      let dict = {
        "getDataFromSnowflake": "dataReady",
        "getQueryIdFromSnowflake": "queryIdReturned",
        "getStatusForQueryId": "queryStatusDone",
        "getZones": "zonesFetched",
        "setSweetEFleetInSnowflake": "queryStatusDone",
        "getSweetEDataFromSnowflake": "dataReady",
        "getStatusForSweetETiles": "tilesReady"
      }
      postMessage({key: dict[functionName], value: sfResult})
    })

  } else {
    postMessage({
      key: "error",
      value: `No calculation found ${functionName ? `for type ${functionName}` : ""}`
    })
  }

  postMessage({ key: "queryStarted", value: false })
})
